export const rootStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px',
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.background.default,
};

export const headerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
};

export const labelsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const actionsStyles = {
  display: 'flex',
  gap: '8px',
};

export const reviewNotesStyles = {
  marginTop: '4px',
};
